import React from 'react';
import clazz from 'classnames';
import styles from './index.module.less';
const defaultRender = (item) => {
    return <div className={styles['base-list-item']}>{item}</div>;
};
export default function BaseList(props) {
    const { title, className, style = {}, list, render = defaultRender } = props;
    console.log(style);
    return (<div className={clazz(styles['base-list'], className)} style={style}>
      <header>{title}</header>

      <main>
        <div className={styles['base-list-wrapper']}>
          {list.map((item, index) => render(item, index))}
        </div>
      </main>
    </div>);
}
